module.exports = __webpack_public_path__ + "static/media/ramenbowlart.4f01f937.jpg";